<template>
    <div>
        <div class="wrapper">

           <dashboard-navigation :myProps="fullname"></dashboard-navigation>
            <dashboard-sidebar :myProp="fullname"></dashboard-sidebar>
            <div class="content-wrapper">
                <!-- Content Header (Page header) -->
                <div class="content-header">
                    <div class="container-fluid">
                            <div class="row mb-2">
                            <div class="col-sm-6">
                                <h1 class="m-0 text-dark">Support</h1>
                            </div><!-- /.col -->
                            </div><!-- /.row -->
                        </div><!-- /.container-fluid -->
                </div>
                <!-- /.content-header -->
                <br />
                <!-- Main content -->
                <section class="content">
                    <div class="container-fluid">
                        <div class="callout callout-info">
                            <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <br /><br >
                                <div class="alert animated bounceIn support-alert alert-success d-none">
                                    <a class="close alert-close" aria-label="close" v-on:click="hideAlert">&times;</a>
                                    <span class="alert-message-content">{{message}}</span>
                                </div>
                                <div class="form-group">
                                    <label>Subject *</label>
                                    <input type="text" v-model="subject" class="form-control" maxlength="50"/>
                                </div>
                                <br />
                                <div class="form-group">
                                    <label>Contact Email *</label>
                                    <input type="text" v-model="email" class="form-control"/>
                                </div>
                                <br />
                                <div class="form-group">
                                    <label>Description *</label>
                                    <textarea v-model="description" class="form-control"></textarea>
                                </div>
                                <br />
                                <div class="form-group">
                                    <label>Attachment </label><br />
                                    <input type="file" :name="attachment"/>
                                </div>
                                <br />
                                <button class="btn btn-primary" v-on:click="sendEmail()">Send Email</button>
                                <br /><br />
                            </div>
                            </div>
                        </div>
                    </div><!--/. container-fluid -->
                </section>
                <!-- /.content -->
            </div>

            <dashboard-footer></dashboard-footer>
            
        </div>
    </div>
</template>


<script>
const endpoint = 'http://18.208.164.251/api';

export default {
    data(){
        return{
            stanbic_trustpay_user_role: null,
            status: null,
            fullname: "",
            subject: "",
            email: "",
            description: "",
            attachment: "attachment",
            message: ""
        };
    },
    methods:{
        sendEmail: function(){
            if(this.validateCredentials() == "error"){
                return;
            }

            this.showSuccessAlert();
        },
        hideAlert: function(){
            $(".alert").addClass("d-none");
        },
        validateCredentials: function(){

            if(this.subject.trim() == ""){
                this.showErrorAlert('The subject is required');
                return "error";
            }

            if( ! this.validateEmail(this.email.trim()) ) {
                this.showErrorAlert('The email must be of the valid format');
                return "error";
            }

            if(this.description.trim() == ""){
                this.showErrorAlert('The description is required');
                return "error";
            }
        },
        validateEmail: function(email){

            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        return re.test(String(email).toLowerCase());

        },
        showErrorAlert: function(message){

            $(".alert").addClass("d-none");
            $(".support-alert").removeClass("alert-success").addClass("alert-danger");
            this.message = message;
            $(".support-alert").removeClass("d-none");

        },
        showSuccessAlert: function(){

            $(".alert").addClass("d-none");
            $(".support-alert").removeClass("alert-danger").addClass("alert-success");
            this.message = "Your email has been sent!";
            $(".support-alert").removeClass("d-none");

        }

    },
    beforeCreate: function () {
        console.log(this.$session.get('trustpayauthtoken'));
        console.log("Role - "+this.$session.get('stanbic_trustpay_user_role'));

        var userDetailsEndpoint = endpoint +'/customer';
        console.log("Endpoint - "+userDetailsEndpoint);

        if(this.$session.get('stanbic_trustpay_user_role') == "seller"){
            userDetailsEndpoint = endpoint +'/seller/account';
            console.log("Endpoint - "+userDetailsEndpoint);
        }

        this.$http.get(userDetailsEndpoint, { headers: {'Authorization': 'Bearer ' + this.$session.get('trustpayauthtoken') } })
            .then( 
                response => { //success
                    return response.json();
                }, 
                response => { //error
                    console.log("Login Err");
                    return response.json();
                    //this.$session.destroy();
                    //this.$router.push('/login');
                }
            )
            .then(user => { 
                if(user.status == "success" && user.message == "customer_details"){
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    this.email = user.data.email;
                    console.log("stats "+this.status);
                }else if (user.status == "success" && user.message == "seller_details"){
                    
                    this.status = "done";
                    this.fullname = user.data.firstname + " " + user.data.lastname;
                    this.email = user.data.email;
                    console.log("stats "+this.status);

                    /*
                    if(user.data.verified == 0){
                        this.$router.push('/myescrow/verify');
                    }
                    */

                }else{
                    alert("Your session has timed out. Please login again");
                    this.$session.destroy();
                    this.$router.push('/login');
                    //this.$router.push('/login');
                }
                
                }
            );    
    }
}
</script>



// WEBPACK FOOTER //
// src/components/dashboard/sellersupport.vue